import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface OrderAmountData {
  basePriceOfProduct?: number;
  deliveryFee?: number;
  subTotal?: number;
  orderNo?: string;
  driverCommission?: number;
  adminCommission?: number;
  vendorCommission?: number;
}

@Component({
  selector: 'megastore-admin-order-amount-details',
  templateUrl: './order-amount-details.component.html',
  styleUrls: ['./order-amount-details.component.scss']
})
export class OrderAmountDetailsComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { data: OrderAmountData },
    private dialogRef: MatDialogRef<OrderAmountDetailsComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }
} 